import { DefaultTheme } from 'styled-components';
import { Fonts } from './variablesThemeV2/fonts';
import { Colors } from './variablesThemeV2/colors';
import { Spacing } from './variablesThemeV2/spacing';

export const PineconeTheme: DefaultTheme = {
  fonts: new Fonts(),
  colors: new Colors(),
  spacing: new Spacing(),
};
